import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { setupApiClient } from "@/api/setup";
import "@fontsource-variable/inter";
import "../styles/index.css";
import { App } from "./App";

setupApiClient();

async function enableMocking() {
  if (import.meta.env.VITE_MOCK_API !== "true") {
    return;
  }

  const { worker } = await import("@/mocks/browser");
  await worker.start({
    onUnhandledRequest: "bypass",
    quiet: false,
  });
}

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element not found");
}

enableMocking().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
